import { setSelectedShipId } from "@/stores/slice/ownerslice/ownerslice";
import { Select, Spin } from "antd";
import { Ship } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";

const ShipDropdown = (props) => {
  const dispatch = useDispatch();
  const { control, setValue } = useForm({});
  const [shiplist, setShiplist] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Accessing ship details and selected ship ID from Redux state
  const { shipdetails, selectedShipId } = useSelector((state) => state.owner);

  const storedshipid = parseInt(localStorage.getItem("imo_number") || 0);

  useEffect(() => {
    if (shipdetails && shipdetails?.length) {
      const shipinfo = shipdetails.map((x) => ({
        label: x.name,
        value: x.imo_number,
      }));
      setShiplist(shipinfo);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }, [shipdetails]);

  useEffect(() => {
    if (shiplist.length > 0) {
      const initialShipId = storedshipid || shiplist[0].value;
      const selectedShipInfo = shiplist.find(
        (item) => item.value === initialShipId
      );
      if (selectedShipInfo) {
        dispatch(setSelectedShipId(selectedShipInfo.value));
        setValue("ship_id", selectedShipInfo.value);
        localStorage.setItem("imo_number", selectedShipInfo.value);
        localStorage.setItem("ship_id", selectedShipInfo.value);
       }
    }
  }, [shiplist, dispatch, setValue]);

  const onChangeShip = (value) => {
    dispatch(setSelectedShipId(value));
    localStorage.setItem("imo_number", value);
    localStorage.setItem("ship_id", value);
    window.location.reload();
  };

  // Show loading state
  if (isLoading) {
    return (
      <div style={{ width: "27vh", textAlign: "center" }}>
        <Spin size="small" />
      </div>
    );
  }

  // Show message if no ships available
  if (shiplist.length === 0) {

    return (
      <div style={{ width: "27vh" }}>
        <Select
          disabled
          placeholder="No ships available"
          style={{ width: "100%" }}
        />
      </div>
    );
  }

  return (
    <Controller
      name="ship_id"
      control={control}
      render={({ field }) => (
        <Select
          showSearch
          value={selectedShipId}
          style={{ width: "27vh" }}
          filterSort={(optionA, optionB) =>
            (optionA.label ?? "")
              .toLowerCase()
              .localeCompare((optionB.label ?? "").toLowerCase())
          }
          {...field}
          onChange={(value) => {
            field.onChange(value);
            onChangeShip(value);
          }}
          placeholder="Select Ship"
        >
          {shiplist.map((x) => (
            <Select.Option key={x.value} value={x.value}>
              <span>
                <Ship size={18} className="me-3 mb-1" />
                {x.label} - {x?.value}
              </span>
            </Select.Option>
          ))}
        </Select>
      )}
    />
  );
};

export default ShipDropdown;